// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button-alert-mini-map {
  width: 100%;
  height: 200px;
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid #2a2a2a;
  background: #0a0a0a;
}

.button-alert-mini-map__marker {
  background: transparent;
  border: none;
}

.button-alert-mini-map__dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: 2px solid #fff;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.35);
}
`, "",{"version":3,"sources":["webpack://./src/components/ButtonAlertMiniMap.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,yCAAyC;AAC3C","sourcesContent":[".button-alert-mini-map {\n  width: 100%;\n  height: 200px;\n  border-radius: 10px;\n  overflow: hidden;\n  border: 1px solid #2a2a2a;\n  background: #0a0a0a;\n}\n\n.button-alert-mini-map__marker {\n  background: transparent;\n  border: none;\n}\n\n.button-alert-mini-map__dot {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  border: 2px solid #fff;\n  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.35);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
